import React from "react";
import classes from "./Team.module.css";
import {CardSingle} from "../../UI/Cards";
import ForumPIC from  "../../Assets/forum.png";
import Button from "react-bootstrap/Button";

const Forum = () => {
    return (
        <div className={classes.Intro}>
            <h1 className={classes.focusLine}>
                <span>FORUM GANDHI PT</span>
            </h1>
            <CardSingle>
                <div className={classes.blackcard}>
                    <img
                        className={classes.portrait}
                        src={ForumPIC}
                        alt=""
                    />
                </div>
                <div className={classes.container1}>
                    <p>
                        Forum is a Registered Physiotherapist with the College of Physiotherapists of Ontario. She holds
                        a Masters Degree in Orthopedics and Sports Physiotherapy and has trained as a Pelvic Floor
                        Physiotherapist and Dry Needling practitioner. Forum has gained over 12 years of experience
                        working various on & off field sporting events, outpatient & inpatient care in India and Canada,
                        musculoskeletal and sports injuries. Forum has won several medals at the national level in India
                        from 2004-2013 in spring board diving. Growing up as an elite athlete with limited resources she
                        thoroughly understands the impact of injuries and the importance of preventative care for high
                        performance sport and quality of life.
                        <br/>
                        <br/>
                        Forum’s practice revolves around a holistic approach of small sustainable changes considering
                        the area of pain, restoring function, and re-integrating clients back into their functional
                        routines. She strongly emphasizes the essential connection between muscles and mind for optimal
                        movement.
                        <br/>
                        <br/>
                        Forum has taken a keen interest and advanced her training in pelvic physiotherapy including
                        treatment of male and female pelvic pain, incontinence, pelvic-prolapse, endometriosis, and
                        pre/post-natal conditions. Notably, Forum has a special passion for improving the quality of
                        life for the geriatric population and high performance athletes.
                        <br/>
                        <br/>
                        Forum continues to advance her knowledge and skill-set with several courses in manual therapy,
                        neural mobilization, dry needling and clinical Pilates for rehabilitation. She is a mom to an
                        energetic toddler and loves spending time sharing an active lifestyle with him.
                        <br/>
                        <br/>
                    </p>
                    {/**
                     * Add Assocation Logos
                     */}
                </div>
            </CardSingle>
            <a className={classes.bookSpecial} href="https://reconnectphysiotherapyandwellness.janeapp.com">
                <Button
                    variant="default"
                >
                    BOOK WITH FORUM
                </Button>
            </a>
        </div>
    );
};

export default Forum;